<template>
  <div>
    <currency-field
      :field="field"
      :value="value"
      @input="updateValueData"
    ></currency-field>
    <input type="hidden" :name="name" :value="valueData" />
  </div>
</template>

<script>
import CurrencyField from './CurrencyField';

export default {
  components: { CurrencyField },
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      valueData: this.value
    };
  },
  methods: {
    updateValueData(v) {
      this.valueData = v;
    }
  }
};
</script>
